import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Contact } from "../authSliceLogin/authSliceLogin";
import dayjs from "dayjs";

interface IOrganization {
  id: number;
  inn: string | null;
  ogrn: string | null;
  name: string | null;
  phone_number: string | null;
  email: string | null;
  snils: string | null;
  created_at: string;
  updated_at: string;
}

export interface Chronology {
  bank_id: number;
  commission_agent_rate: string;
  end_date: string;
  excess_agent: string;
  id: number;
  start_date: string;
  user_id: number;
}
export interface AgentChronology {
  agentDataChronologyToday: Chronology;
  chronologies: Chronology[];
  id: number;
  title: string;
}

export interface IUserContract {
  id: number;
  item_id: number;
  type: string;
  start_contract: string;
  number_contract: string;
  is_sign: boolean;
}

export interface IAgent {
  id: number;
  organization_id: number;
  role_id: number;
  surname: string;
  name: string;
  patronymic: string | null;
  email: string;
  image_path: string;
  inn: string | null;
  phone_number: string | null;
  type: string;
  is_banned: boolean;
  organization: IOrganization | null;
  is_enabled: boolean;
  is_referral?: boolean;
  email_verify?: boolean;
  contacts?: Contact[];
  user_contract?: IUserContract[];
  connect_data?: string;
  agentChronologies: AgentChronology[];
}

interface IAgentFormInput {
  id?: number;
  surname: string;
  name: string;
  patronymic: string | null;
  email: string;
  inn: string;
  phone_number: string | null;
  organization_inn: string | null;
  organization_ogrn: string | null;
  organization_name: string | null;
  organization_email: string | null;
  organization_phone_number: string | null;
  is_enable?: boolean;
  contacts?: Contact[];
  user_contract?: IUserContract[];
  agentChronologies: AgentChronology[];
}
interface IAgentSelected {
  id?: number;
  full_name: string;
  organization_name: string;
  inn: string;
  ogrn: string;
  email: string;
  phone_number: string | null;
  is_enable?: boolean;
  is_referral?: boolean;
  contacts?: Contact[];
  user_contract?: IUserContract[];
  connect_data?: string;
  agentChronologies: AgentChronology[];
}

interface IAgentForm {
  AGENT_FORM_DISABLED: boolean;
  AGENT_FORM_INITIAL: IAgentFormInput;
  AGENT_FORM_TYPE: "EDIT" | "INFO";
}

interface IListAgentState {
  LIST_AGENT_ACTIVE: IAgent[];
  LIST_AGENT_ARCHIVE: IAgent[];
  SELECTED_AGENT: IAgentSelected;
  AGENT_FORM: IAgentForm;
}

const initialState: IListAgentState = {
  LIST_AGENT_ACTIVE: [],
  LIST_AGENT_ARCHIVE: [],
  SELECTED_AGENT: {
    id: 0,
    full_name: "",
    organization_name: "",
    inn: "",
    ogrn: "",
    email: "",
    phone_number: "",
    is_enable: false,
    contacts: [],
    agentChronologies: [],
  },
  AGENT_FORM: {
    AGENT_FORM_DISABLED: true,
    AGENT_FORM_INITIAL: {} as IAgentFormInput,
    AGENT_FORM_TYPE: "INFO",
  },
};

const setAgentData = (agent: IAgent) => {
  const nameParts = [agent.surname, agent.name, agent.patronymic].filter(
    Boolean,
  );
  const full_name = nameParts.join(" ");

  let inn = "";
  let ogrn = "";
  let organization_name = "";

  if (agent.organization) {
    inn = agent.organization.inn ? agent.organization.inn : "";
    ogrn = agent.organization.ogrn ? agent.organization.ogrn : "";
    organization_name = agent.organization.name ? agent.organization.name : "";
  } else if (agent.inn) {
    inn = agent.inn;
  }
  return {
    id: agent.id ? agent.id : 0,
    full_name: `${full_name}`,
    organization_name: `${organization_name}`,
    inn: inn,
    ogrn: `${ogrn}`,
    email: `${agent.email}`,
    phone_number: `${agent.phone_number}`,
    is_enable: agent.is_enabled,
    contacts: agent.contacts,
    user_contract: agent.user_contract,
    connect_data: agent.connect_data,
    agentChronologies: agent.agentChronologies,
    is_referral: agent?.is_referral,
  };
};

const setFormAgentData = (agent: IAgent) => {
  return {
    id: agent.id ?? 0,
    surname: agent.surname ?? null,
    name: agent.name ?? null,
    patronymic: agent.patronymic ?? null,
    email: agent.email ?? null,
    inn: agent.inn ?? "",
    phone_number: agent.phone_number ?? null,
    organization_inn: agent.organization?.inn ?? null,
    organization_ogrn: agent.organization?.ogrn ?? null,
    organization_name: agent.organization?.name ?? null,
    organization_email: agent.organization?.email ?? null,
    organization_phone_number: agent.organization?.phone_number ?? null,
    contacts: agent.contacts,
    user_contract: agent.user_contract,
    agentChronologies: agent.agentChronologies,
  };
};

// interface API_AGENT_EDIT_REQUEST {
//   user: {
//     id: number;
//     surname: string;
//     name: string;
//     patronymic: string;
//     email: string;
//     inn: string | number;
//     phone_number: string;
//   };
//   organization: {
//     inn: string | number;
//     ogrn: string;
//     name: string;
//     phone_number?: string;
//     email?: string;
//     snils?: string;
//   } | null;
// }

// const API = new API_CENTER();
// export const API_LIST_AGENT_ARCHIVE = createAsyncThunk<
//   { agent_id: number; is_enabled: boolean },
//   { agent_id: number; is_enabled: boolean },
//   {
//     rejectValue: string;
//   }
// >(
//   "listAgentSlice/API_LIST_AGENT_ARCHIVE",
//   async (value, { rejectWithValue }) => {
//     const response = await API.GET_API(
//       `user/${value.agent_id}/enable`,
//       "PATCH",
//       {
//         is_enabled: value.is_enabled,
//       }
//     );
//     if (response.success) {
//       return { agent_id: value.agent_id, is_enabled: value.is_enabled };
//     } else {
//       return rejectWithValue(response);
//     }
//   }
// );

// export const API_LIST_AGENT_EDIT = createAsyncThunk<
//   IAgent,
//   API_AGENT_EDIT_REQUEST,
//   {
//     rejectValue: string;
//   }
// >("listAgentSlice/API_LIST_AGENT_EDIT", async (value, { rejectWithValue }) => {
//   const response = await API.GET_API(`user/${value.user.id}`, "PUT", {
//     user: {
//       surname: value.user.surname,
//       name: value.user.name,
//       patronymic: value.user.patronymic,
//       email: value.user.email,
//       inn: value.user.inn,
//       phone_number: value.user.phone_number,
//     },
//     organization: {
//       inn: value.organization?.inn,
//       ogrn: value.organization?.ogrn,
//       name: value.organization?.name,
//       phone_number: value.organization?.phone_number,
//       email: value.organization?.email,
//       snils: value.organization?.snils,
//     },
//   });
//   if (response.success) {
//     return response.data;
//   } else {
//     return rejectWithValue(response);
//   }
// });

// страница списка агентов
const listAgentSlice = createSlice({
  name: "LIST_AGENT_SLICE",
  initialState: initialState,
  reducers: {
    // обновить спиоск агентов
    UP_DATE_LIST_AGENT: (state, actions: PayloadAction<IAgent[], string>) => {
      const listAgent = actions.payload.reduce(
        (acc, obj) => {
          if (obj.is_enabled === true) {
            acc.active.push(obj);
          } else {
            acc.archive.push(obj);
          }
          return acc;
        },
        { active: [], archive: [] } as {
          active: IAgent[];
          archive: IAgent[];
        },
      );
      state.LIST_AGENT_ACTIVE = listAgent.active;
      state.LIST_AGENT_ARCHIVE = listAgent.archive;
    },
    // изменить выбранного агента
    CHANGE_SELECTED_AGENT: (state, actions: PayloadAction<IAgent, string>) => {
      state.SELECTED_AGENT = setAgentData(actions.payload);
    },
    // изменить начальные значения формы вывода информации об агенте
    CHANGE_AGENT_FORM_INITIAL: (
      state,
      actions: PayloadAction<IAgent, string>,
    ) => {
      state.AGENT_FORM.AGENT_FORM_INITIAL = setFormAgentData(actions.payload);
    },
    // изменить доступность полей формы для агента
    CHANGE_AGENT_FORM_DISABLE: (
      state,
      actions: PayloadAction<boolean, string>,
    ) => {
      state.AGENT_FORM.AGENT_FORM_DISABLED = actions.payload;
    },
    // изменить тип формы информации об агенте
    CHANGE_AGENT_FORM_TYPE: (
      state,
      actions: PayloadAction<"EDIT" | "INFO", string>,
    ) => {
      state.AGENT_FORM.AGENT_FORM_TYPE = actions.payload;
    },
    // обновить список ангентов архив и активных
    UP_DATE_LIST_AGENT_STORE: (
      state,
      actions: PayloadAction<IAgent[], string>,
    ) => {
      if (actions.payload) {
        const listAgent = actions.payload.reduce(
          (acc, obj) => {
            if (obj.is_enabled === true) {
              acc.active.push(obj);
            } else {
              acc.archive.push(obj);
            }
            return acc;
          },
          { active: [], archive: [] } as {
            active: IAgent[];
            archive: IAgent[];
          },
        );

        state.LIST_AGENT_ACTIVE = listAgent.active;
        state.LIST_AGENT_ARCHIVE = listAgent.archive;
        if (listAgent.active.length > 0) {
          state.SELECTED_AGENT = setAgentData(listAgent.active[0]);
          state.AGENT_FORM.AGENT_FORM_INITIAL = setFormAgentData(
            listAgent.active[0],
          );
        }
      }
    },
    // добавить агента в архив
    AGENT_ARCHIVE: (state, actions) => {
      const updatedListAgent = state.LIST_AGENT_ACTIVE.concat(
        state.LIST_AGENT_ARCHIVE,
      ).map((agent: IAgent) => {
        if (agent.id === actions.payload.agent_id) {
          return {
            ...agent,
            is_enabled: actions.payload.is_enabled,
          };
        }
        return agent;
      });

      const listAgent = updatedListAgent.reduce(
        (acc: { active: IAgent[]; archive: IAgent[] }, agent: IAgent) => {
          if (agent.is_enabled === true) {
            acc.active.push(agent);
          } else {
            acc.archive.push(agent);
          }
          return acc;
        },
        { active: [], archive: [] } as {
          active: IAgent[];
          archive: IAgent[];
        },
      );
      state.LIST_AGENT_ACTIVE = listAgent.active;
      state.LIST_AGENT_ARCHIVE = listAgent.archive;
    },
    // изменить данные об агненте
    AGENT_EDIT: (state, actions) => {
      state.SELECTED_AGENT = setAgentData(actions.payload);
      state.LIST_AGENT_ACTIVE = state.LIST_AGENT_ACTIVE.map((agent: IAgent) =>
        agent.id === actions.payload.id ? actions.payload : agent,
      );
      state.AGENT_FORM.AGENT_FORM_INITIAL = setFormAgentData(actions.payload);
    },
    // добавить новый контакт агенту
    ADD_CONTACT_PERSON_ADMIN: (
      state,
      actions: { payload: { contact: Contact; user_id: number } },
    ) => {
      if (actions.payload) {
        state.SELECTED_AGENT.contacts?.push(actions.payload.contact);
        state.AGENT_FORM.AGENT_FORM_INITIAL.contacts?.push(
          actions.payload.contact,
        );

        state.LIST_AGENT_ACTIVE = state.LIST_AGENT_ACTIVE.map((value) => {
          if (value.id === actions.payload.user_id) {
            const newContacts = value.contacts
              ? [...value.contacts, actions.payload.contact]
              : [];
            return {
              ...value,
              contacts: newContacts,
            };
          }
          return value;
        });
      }
    },
    // удалить контакт у агента
    DELETE_CONTACT_PERSON_ADMIN: (
      state,
      actions: { payload: { user_id: number; id: number } },
    ) => {
      if (actions.payload) {
        state.SELECTED_AGENT.contacts = state.SELECTED_AGENT.contacts?.filter(
          ({ id }) => actions.payload.id !== id,
        );
        state.AGENT_FORM.AGENT_FORM_INITIAL.contacts =
          state.AGENT_FORM.AGENT_FORM_INITIAL.contacts?.filter(
            ({ id }) => actions.payload.id !== id,
          );

        state.LIST_AGENT_ACTIVE = state.LIST_AGENT_ACTIVE.map((value) => {
          if (value.id === actions.payload.user_id) {
            const newContacts = value.contacts
              ? value.contacts.filter(({ id }) => id !== actions.payload.id)
              : [];
            return {
              ...value,
              contacts: newContacts,
            };
          }
          return value;
        });
      }
    },
    // обновить контакт у агента
    UPDATE_CONTACT_PERSON_ADMIN: (
      state,
      actions: { payload: { contact: Contact; user_id: number } },
    ) => {
      if (actions.payload) {
        state.SELECTED_AGENT.contacts = state.SELECTED_AGENT.contacts?.map(
          (value) =>
            value.id === actions.payload.contact.id
              ? actions.payload.contact
              : value,
        );

        state.AGENT_FORM.AGENT_FORM_INITIAL.contacts =
          state.AGENT_FORM.AGENT_FORM_INITIAL.contacts?.map((value) =>
            value.id === actions.payload.contact.id
              ? actions.payload.contact
              : value,
          );

        state.LIST_AGENT_ACTIVE = state.LIST_AGENT_ACTIVE.map((value) => {
          if (value.id === actions.payload.user_id) {
            const newContacts = value.contacts
              ? value.contacts.map((value) =>
                  value.id === actions.payload.contact.id
                    ? actions.payload.contact
                    : value,
                )
              : [];
            return {
              ...value,
              contacts: newContacts,
            };
          }
          return value;
        });
      }
    },
    // обновить контракт для пользователя
    UPDATE_USER_CONTRACT: (
      state,
      actions: { payload: { contract: IUserContract; user_id: number } },
    ) => {
      if (actions.payload) {
        if (state.SELECTED_AGENT.user_contract) {
          state.SELECTED_AGENT.user_contract[0] = actions.payload.contract;
        }

        if (state.AGENT_FORM.AGENT_FORM_INITIAL.user_contract) {
          state.AGENT_FORM.AGENT_FORM_INITIAL.user_contract[0] =
            actions.payload.contract;
        }

        state.LIST_AGENT_ACTIVE = state.LIST_AGENT_ACTIVE.map((value) => {
          if (value.id === actions.payload.user_id) {
            const newContract = value.user_contract
              ? value.user_contract.map((value) =>
                  value.id === actions.payload.contract.id
                    ? actions.payload.contract
                    : value,
                )
              : [];
            return {
              ...value,
              user_contract: newContract,
            };
          }
          return value;
        });
      }
    },
    ADD_AGENT_CHRONOLOGY: (
      state,
      actions: PayloadAction<{ actual: Chronology; last: Chronology }>,
    ) => {
      const selectedAgent = state.SELECTED_AGENT;
      // Обновляем актуальную хронологию (надо сделать по условию)
      const bank = selectedAgent.agentChronologies.filter(
        (bank) => (bank.id = actions.payload.actual.bank_id),
      )[0];

      // Изменяем дату окончания предпоследней записи
      const itemToChangeEndDate = bank.chronologies.pop();
      if (itemToChangeEndDate) {
        itemToChangeEndDate.end_date = dayjs(actions.payload.last.start_date)
          .subtract(1, "day")
          .format("DD-MM-YYYY");
        bank.chronologies.push(itemToChangeEndDate);
      }
      // добавляем новую запись
      bank.chronologies.push(actions.payload.last);
    },
    ADD_AGENT_BANK_CHRONOLOGY: (
      state,
      actions: PayloadAction<AgentChronology>,
    ) => {
      state.SELECTED_AGENT.agentChronologies.push(actions.payload);
    },
  },
  // extraReducers: (builder) => {
  // builder.addCase(API_LIST_AGENT_ARCHIVE.fulfilled, (state, actions) => {
  //   const updatedListAgent = state.LIST_AGENT_ACTIVE.concat(
  //     state.LIST_AGENT_ARCHIVE
  //   ).map((agent) => {
  //     if (agent.id === actions.payload.agent_id) {
  //       return {
  //         ...agent,
  //         is_enabled: actions.payload.is_enabled,
  //       };
  //     }
  //     return agent;
  //   });

  //   const listAgent = updatedListAgent.reduce(
  //     (acc, agent) => {
  //       if (agent.is_enabled === true) {
  //         acc.active.push(agent);
  //       } else {
  //         acc.archive.push(agent);
  //       }
  //       return acc;
  //     },
  //     { active: [], archive: [] } as {
  //       active: IAgent[];
  //       archive: IAgent[];
  //     }
  //   );
  //   state.LIST_AGENT_ACTIVE = listAgent.active;
  //   state.LIST_AGENT_ARCHIVE = listAgent.archive;
  // });
  // builder.addCase(API_LIST_AGENT_ARCHIVE.rejected, (state, actions) => {
  //   const errorMessage = actions.error.message;
  //   message.error(errorMessage);
  // });
  // builder.addCase(API_LIST_AGENT_EDIT.fulfilled, (state, actions) => {
  //   state.SELECTED_AGENT = setAgentData(actions.payload);
  //   state.LIST_AGENT_ACTIVE = state.LIST_AGENT_ACTIVE.map((agent) =>
  //     agent.id === actions.payload.id ? actions.payload : agent
  //   );
  //   state.AGENT_FORM.AGENT_FORM_INITIAL = setFormAgentData(actions.payload);
  // });
  // builder.addCase(API_LIST_AGENT_EDIT.rejected, (state, actions) => {
  //   const errorMessage = actions.error.message;
  //   message.error(errorMessage);
  // });
  // },
});

export const {
  UP_DATE_LIST_AGENT,
  CHANGE_SELECTED_AGENT,
  UP_DATE_LIST_AGENT_STORE,
  CHANGE_AGENT_FORM_INITIAL,
  CHANGE_AGENT_FORM_DISABLE,
  CHANGE_AGENT_FORM_TYPE,
  AGENT_ARCHIVE,
  AGENT_EDIT,
  ADD_CONTACT_PERSON_ADMIN,
  DELETE_CONTACT_PERSON_ADMIN,
  UPDATE_CONTACT_PERSON_ADMIN,
  UPDATE_USER_CONTRACT,
  ADD_AGENT_CHRONOLOGY,
  ADD_AGENT_BANK_CHRONOLOGY,
} = listAgentSlice.actions;
export default listAgentSlice.reducer;
